import {
  Cloud,
  Brain,
  Smartphone,
  Globe,
  ShieldCheck,
  Zap,
  Code,
  Database,
  Server,
  Layers,
  Target,
  Settings,
  BarChart3,
  Search,
  Palette,
  Rocket,
  FileCheck,
  FileText,
  Wrench,
  ClipboardCheck,
  BookOpen,
  CheckSquare,
  ShoppingCart,
  Building2,
  Truck,
  Heart,
  Banknote,
  Sparkles,
  Lightbulb,
  PenTool,
  TestTube,
  PackageCheck,
  Headphones,
  TrendingUp,
  Users,
  Award,
  Star,
  CheckCircle2,
  ArrowRight,
  Lock,
  Cpu,
  Bot,
  LineChart,
  Megaphone,
  Mail,
  Share2,
  type LucideIcon,
} from "lucide-react";

// Process step icon mapping by keyword
const processIcons: Record<string, LucideIcon> = {
  requirement: ClipboardCheck,
  analysis: Search,
  discovery: Search,
  research: Search,
  planning: Target,
  plan: Target,
  strategy: Target,
  design: PenTool,
  prototype: Palette,
  ui: Palette,
  ux: Palette,
  develop: Code,
  development: Code,
  build: Code,
  implement: Code,
  coding: Code,
  test: TestTube,
  testing: TestTube,
  qa: TestTube,
  quality: TestTube,
  deploy: Rocket,
  deployment: Rocket,
  launch: Rocket,
  release: PackageCheck,
  maintain: Wrench,
  maintenance: Wrench,
  support: Headphones,
  monitor: BarChart3,
  monitoring: BarChart3,
  optimize: Settings,
  optimization: Settings,
  review: FileCheck,
  iterate: Settings,
  integration: Layers,
  configure: Settings,
  migrate: Server,
  migration: Server,
  audit: ClipboardCheck,
  assess: Search,
  scale: TrendingUp,
  train: Lightbulb,
  training: Lightbulb,
  deliver: PackageCheck,
};

// Service category icon mapping
const categoryIcons: Record<string, LucideIcon> = {
  "cloud-and-devops": Cloud,
  "cloud-devops": Cloud,
  "custom-enterprise-apps": Code,
  "digital-marketing": Megaphone,
  "e-commerce-website": Globe,
  "emerging-technologies": Brain,
  "mobile-apps-development": Smartphone,
  "software-testing-qa": ShieldCheck,
  "software-testing-and-qa": ShieldCheck,
  "web-app-development": Globe,
};

// Content-type icon mapping
const contentIcons: Record<string, LucideIcon> = {
  cloud: Cloud,
  aws: Cloud,
  azure: Cloud,
  gcp: Cloud,
  ai: Brain,
  ml: Brain,
  machine: Brain,
  neural: Brain,
  blockchain: Lock,
  iot: Cpu,
  mobile: Smartphone,
  app: Smartphone,
  flutter: Smartphone,
  react_native: Smartphone,
  web: Globe,
  website: Globe,
  frontend: Globe,
  backend: Server,
  api: Server,
  database: Database,
  devops: Settings,
  cicd: Settings,
  security: ShieldCheck,
  testing: TestTube,
  seo: Search,
  marketing: Megaphone,
  social: Share2,
  email: Mail,
  analytics: LineChart,
  data: BarChart3,
  automation: Bot,
  rpa: Bot,
  robotic: Bot,
  metaverse: Cpu,
  vr: Cpu,
  ar: Cpu,
  performance: TrendingUp,
  ecommerce: Globe,
};

const dynamicIcons: Record<string, LucideIcon> = {
  Cloud,
  Brain,
  Smartphone,
  Globe,
  ShieldCheck,
  Zap,
  Code,
  Database,
  Server,
  Layers,
  Target,
  Settings,
  BarChart3,
  Search,
  Rocket,
  Lock,
  TrendingUp,
  Users,
  Award,
  Star,
  FileText,
  BookOpen,
  CheckSquare,
  ShoppingCart,
  Building2,
  Truck,
  Heart,
  Banknote,
  Sparkles,
  Bot,
  Megaphone,
};

export function getProcessIcon(title: string): LucideIcon {
  const lower = title.toLowerCase();
  for (const [keyword, icon] of Object.entries(processIcons)) {
    if (lower.includes(keyword)) return icon;
  }
  return Lightbulb;
}

export function getCategoryIcon(slug: string): LucideIcon {
  return categoryIcons[slug] || Code;
}

export function getContentIcon(text: string): LucideIcon {
  const lower = text.toLowerCase();
  for (const [keyword, icon] of Object.entries(contentIcons)) {
    if (lower.includes(keyword)) return icon;
  }
  return Zap;
}

export function isEmojiIcon(iconKey?: string | null) {
  if (!iconKey) {
    return false;
  }

  return /\p{Extended_Pictographic}/u.test(iconKey);
}

export function resolveIconKey(iconKey?: string | null, fallback: LucideIcon = Zap): LucideIcon {
  if (!iconKey) {
    return fallback;
  }

  return dynamicIcons[iconKey] || fallback;
}

// Stat icons
export const statIcons = { Users, Award, TrendingUp, Star, CheckCircle2 };

// Re-export commonly used icons
export {
  Cloud,
  Brain,
  Smartphone,
  Globe,
  ShieldCheck,
  Zap,
  Code,
  ArrowRight,
  CheckCircle2,
  TrendingUp,
  Users,
  Award,
  Star,
  Target,
  Rocket,
  BarChart3,
  Lightbulb,
  Layers,
  Database,
  Server,
  Lock,
  Search,
  Settings,
  FileText,
  BookOpen,
  CheckSquare,
  ShoppingCart,
  Building2,
  Truck,
  Heart,
  Banknote,
  Sparkles,
  Bot,
  type LucideIcon,
};
